import React from "react";

export type TabsV4Item<K extends string> = { key: K; label: React.ReactNode };

type TabsV4Props<K extends string> = {
  items: TabsV4Item<K>[];
  active: K;
  onChange: (key: K) => void;
  ariaLabel: string;
};

/** แถบแท็บบนหัว content (class hv4-tabs ใน HISV4.scss) */
const TabsV4 = <K extends string>(props: TabsV4Props<K>) => (
  <div className="hv4-tabs" role="tablist" aria-label={props.ariaLabel}>
    {props.items.map((item) => (
      <button
        key={item.key}
        type="button"
        role="tab"
        aria-selected={item.key === props.active}
        className={`hv4-tab${item.key === props.active ? " hv4-tab--active" : ""}`}
        onClick={() => props.onChange(item.key)}
      >
        {item.label}
      </button>
    ))}
  </div>
);

export default TabsV4;
